<template>
  <Content>
    <VideoWithButton :stopOnNext="true" @video-confirmed="next" />

    <Dialog v-model="error">
      <Card>
        <CardHeader>
          <CardTitle v-if="errNoRecorder">
            {{ $t('error_unsupported_media_recorder_header') }}
          </CardTitle>
          <CardTitle v-else>
            {{ $t('error_generic_header') }}
          </CardTitle>
        </CardHeader>
        <CardBody center>
          <CardText v-if="errNoRecorder">
            {{ $t('error_unsupported_media_recorder_body') }}
          </CardText>
        </CardBody>
        <CardActions>
          <Button @click="handleLogout" type="secondary">{{
            $t('button_sign_out')
          }}</Button>
          <Button @click="next">{{ $t('button_continue') }}</Button>
        </CardActions>
      </Card>
    </Dialog>
  </Content>
</template>

<script>
import { mapState } from 'vuex'
import {
  Button,
  Content,
  Dialog,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardText,
  CardActions
} from '@neurotrack/web-shared-components'
import VideoWithButton from '@/components/VideoWithButton/VideoWithButton.vue'

/* eslint-disable no-unused-vars */
export default {
  name: 'VideoCheck',
  components: {
    Button,
    Content,
    VideoWithButton,
    Dialog,
    Card,
    CardHeader,
    CardTitle,
    CardBody,
    CardText,
    CardActions
  },
  computed: {
    ...mapState('video', ['error', 'errNoRecorder'])
  },
  methods: {
    next() {
      this.$router.push({ name: 'Home' })
    },
    handleLogout() {
      this.logout()
      this.$router.push({ path: '/login' })
    }
  }
}
</script>
